import { CategoryPageVisitPluginProps, CategoryPageVisitPluginStateProps } from '../../types/components/user-interest-analytics/CategoryPageVisitPlugin';
import { User } from '../../types/api/UsersTypes';
import { CategoryResponse } from '../../types/api/CategoriesIndexTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { touchCookie } from '../../helpers/analytics/userInterestAnalytics';
import algoliaHelpers from '../../helpers/algolia';

import { QUERY_PARAMS as ALGOLIA_QUERY_PARAMS } from '../../constants/algolia';

const CategoryPageVisitPlugin: React.FC<CategoryPageVisitPluginProps> = ({
  authenticated,
  user,
  category,
}) => {
  const router = useRouter();
  const { pushCategoryViewEvent: pushAlgoliaCategoryViewEvent } = algoliaHelpers;
  // Because the category page is the same component instance
  // unless you navigate away, we need to keep track of the current category
  // being already reported to prevent false click events triggered by other factors
  const [lastReportedCategory, setLastReportedCategory] = useState<CategoryResponse>();

  const visitReported = (): boolean => {
    if (!lastReportedCategory || !category) return false;
    return lastReportedCategory?.id === category?.id;
  }

  const reportCategoryPageVisit = async () => {
    try {
      setLastReportedCategory(category);
      await pushAlgoliaCategoryViewEvent(user, category, router.query[ALGOLIA_QUERY_PARAMS.QUERY_ID] as string);
    } catch {};
  };

  useEffect(() => {
    touchCookie();
  }, []);

  useEffect(() => {
    if (authenticated !== true && authenticated !== false || !!visitReported() || !category) return;
    reportCategoryPageVisit();
  }, [authenticated, category]);

  return <></>;
};

const mapStateToProps = (state: ApplicationState): CategoryPageVisitPluginStateProps => ({
  user: state.auth.user as User,
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(CategoryPageVisitPlugin);
